import Vue from "vue";
import Router from "vue-router";
import Search from "./views/Search.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "search",
      component: Search,
      props: route => ({
        departureDate: route.query.departureDate,
        preferredCabin: route.query.preferredCabin,
        departureAirport: route.query.departureAirport,
        arrivalAirport: route.query.arrivalAirport,
        adults: route.query.adults,
        children: route.query.children,
        infants: route.query.infants,
        returnDate: route.query.returnDate,
        tripType: route.query.tripType
      })
    },
    {
      path: "/results",
      name: "results",
      component: () => import("./views/Results.vue")
    },
    {
      path: "/details",
      name: "details",
      component: () => import("./views/Details.vue")
    },
    {
      path: "/threeDSecure",
      name: "threeDSecure",
      component: () => import("./views/threeDSecure.vue")
    },
    {
      path: "/ipay",
      name: "ipay",
      component: () => import("./views/OzowIframe.vue")
    },
    {
      path: "/confirmation",
      name: "confirmation",
      component: () => import("./views/Confirmation.vue")
    },
    {
      path: "/failure",
      name: "failure",
      component: () => import("./views/Failure.vue")
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});
